import { evaluate } from "mathjs";
import { validateDateTimeMicro } from "../utils/validation";
export const computeFormula = (formData, formula) => {
    try {
        let formulaParsed = formula.slice();
        for (let key in formData) {
            if (formula.includes(key)) {
                const value = gettingNumericValue(formData[key]);
                const regex = new RegExp(key, "g");
                formulaParsed = formulaParsed.replace(regex, value.toString());
            }
        }
        const result = evaluate(formulaParsed);
        return typeof result === "number" ? result.toString() : "";
    }
    catch (_a) {
        return "";
    }
};
const gettingNumericValue = (data) => {
    if (typeof data === "string" && validateDateTimeMicro(data)) {
        return new Date(data).getTime() / 1000;
    }
    else if (typeof data === "object" &&
        data.hasOwnProperty("dateTime") &&
        validateDateTimeMicro(data.dateTime)) {
        return new Date(data.dateTime).getTime() / 1000;
    }
    return data;
};
//# sourceMappingURL=formula.js.map